
import { Game } from './game';
import { initFeedback } from './feedback';

function main(): void {
  new Game();
  initFeedback();
}

main();
